<script lang="ts">const { id = '', alignment = 'left', isOpen = false, children } = $props();
</script>

<!-- 
  NOTE:
  To ensure that the flyout is visibily hidden until the css is ready, 
  we use --flyout-visibility variable with hidden as default to toggle visibility
-->
<div
  id="nav-flyout-{id}"
  class="Flyout align-{alignment}"
  class:isOpen
  style:visibility="var(--flyout-visibility, hidden)"
>
  <div class="flyout-container">
    {@render children?.()}
  </div>
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Flyout {
  box-sizing: border-box;
  position: absolute;
  overflow: hidden;
  left: 10px;
  top: calc(100% + 4px);
  background-color: var(--color-flyout-background, var(--color-neutral-1000, #fff));
  border-radius: 16px;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.16);
  width: 320px;
  max-height: 0;
  transition: max-height 300ms ease-out, visibility 300ms step-end;
  --flyout-visibility: hidden;
  pointer-events: none;
}
.Flyout .flyout-container {
  padding: 20px;
}
.Flyout.isOpen {
  --flyout-visibility: visible;
  pointer-events: auto;
  max-height: 100vh;
  transition: max-height 300ms ease-out, visibility 300ms step-start;
}
.Flyout.isOpen :global(.ItemList.slide-in-from-top li) {
  opacity: 1;
  transform: translateY(0px);
  transition: opacity 300ms ease-out, transform 300ms ease-out;
  transition-delay: calc(0s + var(--item-list-item-number) * 20ms);
}
.Flyout.isOpen :global(.Status.slide-in-from-top div) {
  opacity: 1;
  transform: translateY(0px);
  transition: opacity 300ms ease-out, transform 300ms ease-out;
  transition-delay: calc(0s + var(--item-number) * 20ms);
}
.Flyout.isOpen :global(.LinkList .slide-in-from-top) {
  opacity: 1;
  transform: translateY(0px);
  transition: opacity 300ms ease-out, transform 300ms ease-out;
  transition-delay: calc(0s + var(--link-list-item-number) * 20ms);
}
.Flyout :global(.ItemList.slide-in-from-top li) {
  opacity: 0;
  transform: translateX(0px) translateY(-4px);
}
.Flyout :global(.Status.slide-in-from-top div) {
  opacity: 0;
  transform: translateX(0px) translateY(-4px);
}
.Flyout :global(.LinkList .slide-in-from-top) {
  opacity: 0;
  transform: translateX(0px) translateY(-4px);
}

.align-right {
  left: auto;
  right: 0;
}</style>
